import { render, staticRenderFns } from "./AutoAbsolute.vue?vue&type=template&id=3c16a3e9&scoped=true"
import script from "./AutoAbsolute.vue?vue&type=script&lang=ts"
export * from "./AutoAbsolute.vue?vue&type=script&lang=ts"
import style0 from "./AutoAbsolute.vue?vue&type=style&index=0&id=3c16a3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16a3e9",
  null
  
)

export default component.exports